<template>

<div class="list-view">
	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" ref="search_term" v-model="localSearchTerm" placeholder="Search..." @keyup.enter="$emit('search', localSearchTerm)" v-focus>
			<div class="button action input-go" @click="$emit('search', localSearchTerm)"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="$emit('updatePage', $event)"></pagination>
		</div>
	</div>

	<div class="close-filters" @click="showFilters = !showFilters" v-if="!showFilters">X</div>

	<slot name="filters" v-if="showFilters"></slot>

	<list-component class="list page-list list-entries" :definition="definition" :list="list" @clicked="$emit('getDetail', $event)" :showRemove="showRemove" @auditRemove="$emit('auditRemove', $event)"></list-component>
</div>

</template>

<script>
export default {
	name: 'list-view',
	props: [ 'searchTerm', 'paging', 'definition', 'list', 'showRemove' ],
	data() {
		return {
			showFilters: true,
			localSearchTerm: null
		}
	},
	watch: {
		searchTerm(newVal) {
			this.localSearchTerm = newVal
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
